import http from "@/config/http";

/*************** <FOLDERS> *********************/
export const getFolderItems = async (id) => http.get(`v1/folders/${id}/items`);

export const getFolderContent = async (id) => http.get(`v1/folders/${id}`);

export const getFolderContentByRole = async (roleId,id) => http.get(`v1/roles/${roleId}/folders/${id}`);

/*************** <FOLDERS/> *********************/